module.exports = __webpack_public_path__ + "static/media/icon-car-default.25b11a12.svg";